import { useTranslation } from 'react-i18next'
import cn from 'classnames'
import Link from '../common/util/input/Link'

export const EditorBreadCrumbs = ({
    collectionUniqueName,
    collectionDisplayName,
    path,
    pathDisplayName,
    schemaName,
    templateId,
    releaseId,
    poolId,
    newDisplay,
    createNew,
}) => {
    const { t } = useTranslation('common')
    return (
        <div
            className={cn(
                'flex flex-wrap pl-4 md:h-10 text-black dark:!text-white',
            )}
        >
            <div>
                <Link href={`/creator`}>
                    <div className="hover:text-primary">
                        {t('navigation.creator')}
                    </div>
                </Link>
            </div>
            {collectionUniqueName && (
                <div className="mx-1">
                    <Link href={`/creator/${collectionUniqueName}`}>
                        <div className="hover:text-primary">
                            {`> ${
                                collectionUniqueName !== 'new'
                                    ? collectionDisplayName
                                        ? collectionDisplayName
                                        : collectionUniqueName
                                    : t('editor.new_collection')
                            }`}
                        </div>
                    </Link>
                </div>
            )}
            {path && collectionUniqueName ? (
                <div className="mx-1">
                    <Link href={`/creator/${collectionUniqueName}/${path}`}>
                        <div className="hover:text-primary">{`> ${
                            pathDisplayName ? pathDisplayName : path
                        }`}</div>
                    </Link>
                </div>
            ) : (
                ''
            )}
            {path && collectionUniqueName && schemaName ? (
                <div className="mx-1">
                    <Link
                        href={`/creator/${collectionUniqueName}/${path}/${schemaName}`}
                    >
                        <div className="hover:text-primary">
                            {`> ${
                                schemaName !== 'new'
                                    ? schemaName
                                    : t('editor.new_schema')
                            }`}
                        </div>
                    </Link>
                </div>
            ) : (
                ''
            )}
            {path && collectionUniqueName && schemaName && templateId ? (
                <div className="mx-1">
                    <Link
                        href={`/creator/${collectionUniqueName}/${path}/${schemaName}/${templateId}`}
                    >
                        <div className="hover:text-primary">
                            {`> ${
                                templateId !== 'new'
                                    ? templateId
                                    : t('editor.new_template')
                            }`}
                        </div>
                    </Link>
                </div>
            ) : (
                ''
            )}
            {path && releaseId && poolId ? (
                <div className="mx-1">
                    <Link
                        href={`/creator/${collectionUniqueName}/${path}/${releaseId}/editpool/${poolId}`}
                    >
                        <div className="hover:text-primary">
                            {`> ${releaseId} > ${t(
                                'editor.pool_editor',
                            )} > ${poolId}`}
                        </div>
                    </Link>
                </div>
            ) : (
                ''
            )}
            {path && createNew ? (
                <div className="mx-1">
                    <Link
                        href={`/creator/${collectionUniqueName}/${path}${
                            releaseId ? `/${releaseId}` : ''
                        }/${createNew}`}
                    >
                        <div className="hover:text-primary">
                            {`> ${
                                releaseId ? `${releaseId} > ` : ''
                            }${newDisplay}`}
                        </div>
                    </Link>
                </div>
            ) : (
                ''
            )}
        </div>
    )
}
